import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
export var ADD_TO_CART;
(function (ADD_TO_CART) {
    ADD_TO_CART["REQUEST"] = "ADD_TO_CART_REQUEST";
    ADD_TO_CART["SUCCESS"] = "ADD_TO_CART_SUCCESS";
    ADD_TO_CART["ERROR"] = "ADD_TO_CART_ERROR";
    ADD_TO_CART["SET_LATEST_BASKET_BUILDING_ITEM"] = "SET_LATEST_BASKET_BUILDING_ITEM";
    ADD_TO_CART["RESET_LATEST_BASKET_BUILDING_ITEM"] = "RESET_LATEST_BASKET_BUILDING_ITEM";
})(ADD_TO_CART || (ADD_TO_CART = {}));
export function addItemToCartAction(cartContext, ignoreErrorCodes = []) {
    return (dispatch) => {
        dispatch({
            type: ADD_TO_CART.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/cart',
            acceptErrors: true,
            action: ADD_TO_CART.REQUEST
        }), { cartContext }).then(json => {
            // check if `Add To Cart` was a success
            // 200 O.K. doesn't mean all is well, check `errorCode` & `errorMessage`
            // response contains hash of all items in cart, so consider only the ones
            // we sent in `listingIds`
            const response = json.RESPONSE;
            const error = Object.keys(cartContext).reduce((prev, curr) => {
                const { errorCode, errorMessage } = get(response, ['cartResponse', curr], {});
                // honouring only first item
                if (!isEmpty(prev))
                    return prev;
                if ((errorCode || errorMessage) && ignoreErrorCodes.indexOf(errorCode) === -1) {
                    return { errorCode, errorMessage };
                }
                return prev;
            }, {});
            if (!isEmpty(error))
                return Promise.reject(error);
            return Promise.resolve(dispatch({
                type: ADD_TO_CART.SUCCESS,
                data: response
            }));
        }, err => {
            const error = err.ERROR_MESSAGE
                ? { errorMessage: err.ERROR_MESSAGE }
                : { errorMessage: stringTemplate('addtoCartDegradeMessage') };
            dispatch({
                type: ADD_TO_CART.ERROR,
                error
            });
            return Promise.reject(error);
        });
    };
}
export function setLatestBasketBuildingItemAction(listingId, imageUrl, basketBuildingTimeoutId) {
    return (dispatch) => {
        dispatch({
            type: ADD_TO_CART.SET_LATEST_BASKET_BUILDING_ITEM,
            data: { listingId, imageUrl, basketBuildingTimeoutId }
        });
    };
}
export function resetLatestBasketBuildingItemAction() {
    return (dispatch) => {
        dispatch({
            type: ADD_TO_CART.RESET_LATEST_BASKET_BUILDING_ITEM
        });
    };
}
